import styled from 'styled-components';
import SearchIcon from '../../../Assets/Icons/default.png';

export const Container = styled.div`
    width: 100%;
`;

export const SearchRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

export const MembersSummaryRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
`;

export const SearchInput = styled.input`
    position: relative;
    width: 500px;
    height: 30px;
    border-radius: 3px;
    border: none;
    background-color: rgba(239, 240, 242, 0.18);

    text-align: left;
    font-size: 14px;
    color: #909fac;
    outline: none;
    padding: 0px 105px 0px 35px;
    box-sizing: border-box;
    z-index: 5;
    background-image: url(${SearchIcon});
    background-repeat: no-repeat;
    background-position: left 10px top 50%;

    @media (min-width: 768px) {
        padding-right: 50px;
    }
`;

export const PlaceholderInput = styled.span`
    position: absolute;
    display: inline-block;
    top: 50%;
    left: 50%;
    font-size: 14px;
    color: #909fac;
    transition: all 0.4s ease;
    transform: translate(-50%, -50%) scale(1);
    z-index: 1;

    ${props => {
        if (props.hidden) {
            return `
        transition: all 0.4s ease;
        transform: translate(-50%, -50%) scale(0);
      `;
        }
    }};
`;

export const AddButton = styled.button`
    width: 100px;
    height: 30px;
    border-radius: 100px;
    background-color: #fff;
    border: none;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: bold;
    cursor: pointer;
    color: black;
    outline: none;

    &:hover {
        background-color: #b3b3b3;
    }

    transition: all 0.5s;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/Members/style.js